import { render, staticRenderFns } from "./WLoading.vue?vue&type=template&id=c5d64ba6&scoped=true"
import script from "./WLoading.vue?vue&type=script&lang=js"
export * from "./WLoading.vue?vue&type=script&lang=js"
import style0 from "./WLoading.vue?vue&type=style&index=0&id=c5d64ba6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d64ba6",
  null
  
)

export default component.exports